/**
 * Point d'entrée UNIQUE vers `web-commun/connexion-google` (bouton, retour OAuth, contrôle d'accès) pour la console Dispatch.
 *
 * ⚠️ Console d'ÉQUIPE : « Continuer avec Google » ne CRÉE jamais d'accès. Il se rattache à un compte DÉJÀ existant de même
 * e-mail vérifié ; ensuite `controlerPersonnel` (api/controleAcces.ts) exige un profil `admin` / `dispatcher` et déconnecte
 * sinon. Les clients de SwiftEats, eux, peuvent créer un compte Google dans leurs apps : ils n'ont simplement aucun accès ici.
 * Voir `SwiftDeliver/docs/GOOGLE-CONSOLES.md`.
 */
import { creerConnexionGoogle, sessionViaGoogle } from '../../../../../web-commun/connexion-google'
import { CLE_PUBLISHABLE, URL_SUPABASE, supabase } from './supabase'

export { BoutonGoogle, erreurDeRetourOAuth } from '../../../../../web-commun/connexion-google'

export const connexionGoogle = creerConnexionGoogle({ client: supabase, url: URL_SUPABASE, cle: CLE_PUBLISHABLE })

/** La session en cours a-t-elle été ouverte par Google ? (lue dans le jeton : vraie aussi après un rechargement) */
export async function sessionOuverteParGoogle(): Promise<boolean> {
  const { data } = await supabase.auth.getSession()
  return sessionViaGoogle(data.session)
}
